import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-roles',
  templateUrl: './manage-roles.component.html'
})
export class ManageRolesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
